import { Autocomplete, Box, Button, TextField, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ChevronDown, Trash2 } from "lucide-react";

import { AssitanceAdjustViewContext } from "../../../components/AssistanceAdjustList/AssistanceAdjustList";
import grain from "../../../assets/images/grain.png";
import "../AssitanceAdjustModals.scss";

export default function DeleteNurseModal() {
	const { selectedNurses, nurses, setShowModal } = useContext(AssitanceAdjustViewContext);
	const [nursesNames, setNursesNames] = useState<string[]>([]);
	const [localSelectedReason, setLocalSelectedReason] = useState("");

	const { isModalLoading, saveMovements } = useContext(AssitanceAdjustViewContext);

	const changeReason = [
		{
			key: "Falta",
			item: "Falta",
		},
		{
			key: "Incapacidad",
			item: "Incapacidad",
		},
		{
			key: "Vacaciones",
			item: "Vacaciones",
		},
		{
			key: "Otro",
			item: "Otro",
		},
	];

	useEffect(() => {
		let nursesNameHelper: string[] = [];

		selectedNurses.map((nurse_id: string) => {
			const nurse = nurses.find((item: any) => item.id === nurse_id);
			nursesNameHelper.push(nurse.nursename);
		});

		setNursesNames(nursesNameHelper);
	}, [selectedNurses]);

	const canSave = (): boolean => {
		return localSelectedReason !== "";
	};

	const handleSave = () => {
		saveMovements({ reason: localSelectedReason });
	};

	return (
		<Box>
			<Box className="modal-header">
				<img
					className="modal-header__grain"
					src={grain}
					alt="background"
				/>
				<Box className="modal-header__title">
					<Trash2 className="modal-header__title__icon" />
					<Box className="modal-header__title__text">
						<Typography className="modal-header__title__text--name">
							Eliminar Profesional{" "}
						</Typography>
						<Typography className="modal-header__title__text--description">
							Elimina a un profesional del turno.
						</Typography>
					</Box>
				</Box>
			</Box>
			<Box className="modal-form__delete-message">
				¿Está seguro de que desea eliminar a los siguientes profesionales?
				<Box
					className="modal-form__delete-message__nurses"
					sx={{
						justifyContent:
							nursesNames?.length > 2 ? "flex-start !important" : "center",
					}}
				>
					{nursesNames?.map((nurseName: string) => (
						<Typography
							className="modal-form__delete-message__nurses__names"
							sx={{
								fontWeight: "700 !important",
							}}
						>
							{nurseName}
						</Typography>
					))}
				</Box>
			</Box>
			<Box className="modal-form__delete-reason">
				<Typography className="modal-form__input-title">Razón de eliminar</Typography>
				<Autocomplete
					id="autocomplete"
					popupIcon={<ChevronDown className="down-icon" />}
					options={changeReason.sort((a, b) => a.item.localeCompare(b.item))}
					getOptionLabel={(option) => option.item}
					onChange={(e, newValue: any) => {
						if (newValue != null) {
							setLocalSelectedReason(newValue.key);
						} else {
							setLocalSelectedReason("");
						}
					}}
					fullWidth
					size="small"
					renderInput={(params) => (
						<TextField
							{...params}
							placeholder="Seleccionar"
							variant="outlined"
							sx={{
								"& .MuiOutlinedInput-root": { height: "3rem" },
							}}
						/>
					)}
					value={
						changeReason.find((reason) => reason.key === localSelectedReason) || null
					}
				/>
			</Box>
			<Box
				className="buttons"
				sx={{
					marginTop: "4.2vh !important",
				}}
			>
				<Button
					className="buttons--close"
					onClick={() => setShowModal(false)}
				>
					Cerrar
				</Button>
				<Button
					id="save-button"
					className="buttons--delete"
					startIcon={<Trash2 className="buttons--save__icon" />}
					onClick={() => handleSave()}
					disabled={!canSave() || isModalLoading}
				>
					Eliminar
				</Button>
			</Box>
			{isModalLoading && (
				<Box>
					<Box className="loader-container"></Box>
					<Box className="loader-container__loader"></Box>
				</Box>
			)}
		</Box>
	);
}
